/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import SecondaryBtn from "../../common/form/SecondaryBtn";
import { Arr, Filter, NoResultFound, TableSearch } from "../../common/svg/AllSvg";
import PaginationComponent from "../../common/form/PaginationComponent";
import { useSelector } from "react-redux";
import useSelectTable from "../../../shared/hooks/use-selectTable";
import Select, { components } from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";
import PageLoader from "../../common/layout/PageLoader";
import moment from "moment";
import { useTranslation } from "react-i18next";
import Error from "../../common/form/Error";

const DropdownIndicator = (props: any) => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <Arr className="min-w-[9px] fill-[#888] dark:fill-textBlackDark" />
            </components.DropdownIndicator>
        )
    );
};

const AllVacancies = () => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const theme: any = useSelector((state: any) => state.ui.theme);
    const { t } = useTranslation('common');
    const [page, setPage] = useState<number>(1);
    const [total, setTotal] = useState<number>(0);
    let styles = useSelectTable(theme);
    const navigate = useNavigate();
    const params = useParams();
    const [data, setData] = useState<any>([])
    const [search, setSearch] = useState<string>("")
    const [debouncedValue, setDebouncedValue] = useState<string>(search);
    const [searchFocus, setSearchFocus] = useState<boolean>(false)
    const [size, setSize] = useState<any>({ label: `10 ${t("recruitment.home.per_page")}`, value: "10" });
    let totalPages: number = Math.ceil(total / +size?.value);
    const [loading, setLoading] = useState<any>(true)
    const [isError, setIsError] = useState<boolean>(false)
    const loaderData: any[] = [1, 2, 3, 4, 5]
    const sizeList: any[] = [{ label: `10 ${t("recruitment.home.per_page")}`, value: "10" }, { label: `20 ${t("recruitment.home.per_page")}`, value: "20" }, { label: `30 ${t("recruitment.home.per_page")}`, value: "30" }]
    const sortByList: any[] = [{ label: `${t("recruitment.home.sort_by")} (Default)`, value: "Sort by (Default)" }]

    const getData = async (s: any) => {
        try {
            setLoading(true)
            setIsError(false)
            let api: any = ""
            if (!!s) {
                api = await useAxios.get(`${(!!lang ? lang : "en") + url?.publicAd}?page=${page}&size=${+size?.value}&search=${s}`)
            } else {
                api = await useAxios.get(`${(!!lang ? lang : "en") + url?.publicAd}?page=${page}&size=${+size?.value}`)
            }

            if (!!api) {
                const res: any = api;

                if (res && res.status === 200) {
                    let arr: any[] = [{
                        "id": "4ef814ec-0a52-4ffa-ac4e-ce7f77210052",
                        "title": "NOTICE - Advt. 2025-01",
                        "adv_no": "MMRCL/HR-Rect./ 2025-01",
                        "last_date_submission": "2025-06-08",
                        "attach_pdf": "https://mmrcl-development.s3.amazonaws.com/media/documents/2459_001.pdf",
                        "status": "closed"
                    }];
                    let arr1: any = arr.concat(res?.data?.results)
                    setData(arr1)
                    // setData(res?.data?.results)
                    setTotal(res?.data?.count)
                    setLoading(false)
                }
            }
        } catch (error) {
            setIsError(true)
            setLoading(false)
            console.error("error while fetching adds", error);
        }
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(search);
        }, 500);

        return () => clearTimeout(timer);
    }, [search]);

    useEffect(() => {
        window.scrollTo(0, 0);
        !!lang && getData("");
    }, [page, size, lang])

    useEffect(() => {
        if (!!lang) {
            let obj: any = sizeList?.find((item: any) => item?.value === size?.value)
            setSize(obj)
        }
    }, [lang])

    return (
        <>
            {loading ?
                <div className="py-[30px] lg:py-[50px] w-full h-full container flex flex-col gap-[15px] sm:gap-[25px]">
                    <div className="overflow-x-auto h-full w-full">
                        <div className="inline-block min-w-full">
                            <div className="overflow-hidden">
                                <table className="table-auto w-full">
                                    <thead className="w-full">
                                        <tr className="w-full bg-[#D9D9D9] dark:border-[#454545] bg-opacity-[0.3] border border-[#D9D9D9] border-opacity-[0.3]">
                                            <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-[#121212] dark:text-white font-bold text-sm leading-snug !text-center">
                                                {t("recruitment.home.ads_list.s_no")}
                                            </th>
                                            <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-[#121212] dark:text-white font-bold text-sm leading-snug !text-left">
                                                {t("recruitment.home.ads_list.add_no")}
                                            </th>
                                            <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-[#121212] dark:text-white font-bold text-sm leading-snug !text-left">
                                                {t("recruitment.home.ads_list.title")}
                                            </th>
                                            <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-[#121212] dark:text-white font-bold text-sm leading-snug !text-left">
                                                {t("recruitment.home.ads_list.last_date")}
                                            </th>
                                            <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-[#121212] dark:text-white font-bold text-sm leading-snug !text-center">
                                                {t("recruitment.home.ads_list.status")}
                                            </th>
                                            <th className="px-[16px] py-[3px] xlx:py-[6px] h-full"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(loaderData) && loaderData.map((item: any, index: number) => (
                                            <tr className="w-full animate-pulse border border-gray-200 dark:border-gray-700 bg-white dark:bg-bgDarkDull" key={index}>
                                                <td className="px-[16px] py-[15px] xlx:py-[30px]">
                                                    <div className="flex items-center justify-center">
                                                        <div className="w-[20px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                    </div>
                                                </td>

                                                <td className="px-[16px] py-[15px] xlx:py-[30px]">
                                                    <div className="flex flex-col gap-[8px]">
                                                        <div className="w-[180px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                        <div className="w-[90px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                    </div>
                                                </td>

                                                <td className="px-[16px] py-[15px] xlx:py-[30px]">
                                                    <div className="w-[180px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                </td>

                                                <td className="px-[16px] py-[15px] xlx:py-[30px]">
                                                    <div className="w-[60px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                </td>

                                                <td className="px-[16px] py-[15px] xlx:py-[30px]">
                                                    <div className="flex items-center justify-center">
                                                        <div className="w-[80px] h-[25px] xlx:h-[30px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                    </div>
                                                </td>

                                                <td className="px-[16px] py-[15px] xlx:py-[30px]">
                                                    <div className="flex items-center justify-end">
                                                        <div className="w-[60px] xlx:w-[94px] rounded-[4px] h-[35px] xlx:h-[40px] bg-gray-200 dark:bg-gray-700"></div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <>
                    {isError ? <Error /> : <div className="py-[30px] lg:py-[50px] w-full h-full container flex flex-col gap-[15px] sm:gap-[25px]">
                        {/* search */}
                        <div className="rounded-[8px] border border-[#E5E5E5] dark:border-[#454545] shadow-[0px_2px_2px_0px_rgba(28,36,51,0.10)] py-[6px] xlx:py-[8.5px] flex flex-col md:items-center md:flex-row md:justify-between h-full w-full px-[15px] xlx:px-[24px]">
                            <div className={`flex items-center gap-[10px] xlx:gap-[13px] w-full bg-white dark:bg-bgDarkDull rounded-[7px] px-[10px] xlx:px-[15px] h-[35px] xlx:h-[40px] ${searchFocus && "bg-[#E5E5E55e] dark:bg-[#34364382]"} hover:bg-[#E5E5E55e] dark:hover:bg-[#34364382] mr-[15px] xlx:mr-[24px]`}>
                                <div className="min-w-[19px] md:min-w-[21px]">
                                    <TableSearch className="xlx:w-auto xlx:h-auto w-[18px] h-[18px] fill-[#121212] dark:fill-textBlackDull" />
                                </div>
                                <input value={search} onChange={(e: any) => setSearch(e.target.value)} autoComplete="off" type="text" className="text-[#6C757D] placeholder:text-[#6C757D] dark:text-textBlackDull dark:placeholder:text-textBlackDull font-medium text-base w-full h-full bg-transparent" placeholder={t("recruitment.home.search_ad")} onFocus={() => setSearchFocus(true)} onBlur={() => setSearchFocus(false)} />
                            </div>
                            <div className="flex items-center md:flex-row flex-col gap-[10px] md:w-auto w-full">
                                <div className="md:h-[30px] xlx:h-[44px] md:w-auto w-full border-b md:border-r border-[#E5E5E5] dark:border-[#454545]"></div>
                                <div className="flex items-center h-full gap-[8px] md:gap-[40px]  justify-between md:w-auto w-full">
                                    <button className="w-fit h-[35px] xlx:h-[40px] flex items-center gap-[10px] xlx:gap-[13px] text-[#121212] dark:text-textBlackDull font-medium text-base px-[7px] xlx:px-[14px] bg-white dark:bg-bgDarkDull rounded-[7px] border border-transparent focus:border-[#E5E5E5] hover:border-[#E5E5E5] dark:focus:border-[#454545] dark:hover:border-[#454545] whitespace-nowrap">
                                        <div className="min-w-[15px] xlx:min-w-[19px]">
                                            <Filter className="xlx:w-auto xlx:h-auto w-[15px] h-[15px] fill-[#1C1B1F] dark:fill-textBlackDull" />
                                        </div>
                                        {t("recruitment.home.filter_more")}
                                    </button>

                                    <SecondaryBtn title={t("grievance.home.banner.search")} css="px-[14px] xlx:px-[27px] uppercase font-bold" onClick={() => getData(debouncedValue)} />
                                </div>

                            </div>
                        </div>


                        {(data?.length === 0) ?
                            <div className="flex flex-col gap-[20px] xlx:gap-[30px] w-full items-center justify-center py-[100px]">
                                <NoResultFound />
                                <h3 className="text-primaryText dark:text-white font-bold">{t("passenger.lost_found.no_search")}</h3>
                            </div>
                            : <>
                                {/* sort & size */}
                                <div className="flex items-center justify-between gap-[10px] w-full mt-[10px] flex-wrap">
                                    <h5 className="font-bold text-[#121212] dark:text-white uppercase">{lang === "en" ? `Showing ${((+page - 1) * +size?.value) + 1} – ${(((+page - 1) * +size?.value) + 1) + 9} of ${data?.length} results` : lang === "hi" ? `${data?.length} में से ${((+page - 1) * +size?.value) + 1} – ${(((+page - 1) * +size?.value) + 1) + 9} परिणाम दिखा रहा है` : `${data?.length} पैकी ${((+page - 1) * +size?.value) + 1} – ${(((+page - 1) * +size?.value) + 1) + 9} निकाल दाखवत आहे`}</h5>

                                    <div className="flex items-center gap-[7px]">
                                        <Select options={sortByList} styles={styles} className="!w-fit" value={{ label: `${t("recruitment.home.sort_by")} (Default)`, value: "Sort by (Default)" }} isSearchable={false} components={{ DropdownIndicator }} classNamePrefix="react-select" />

                                        <Select options={sizeList} styles={styles} className="!w-fit" isSearchable={false} components={{ DropdownIndicator }} classNamePrefix="react-select" value={size} onChange={(e: any) => setSize(e)} />
                                    </div>
                                </div>
                                {/* data */}
                                <div className="overflow-x-auto h-full w-full">
                                    <div className="inline-block min-w-full">
                                        <div className="overflow-hidden">
                                            <table className="table-auto w-full">
                                                <thead className="w-full">
                                                    <tr className="w-full bg-[#D9D9D9] dark:border-[#454545] bg-opacity-[0.3] border border-[#D9D9D9] border-opacity-[0.3]">
                                                        <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-[#121212] dark:text-white font-bold text-sm leading-snug !text-center">
                                                            {t("recruitment.home.ads_list.s_no")}
                                                        </th>
                                                        <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-[#121212] dark:text-white font-bold text-sm leading-snug !text-left">
                                                            {t("recruitment.home.ads_list.add_no")}
                                                        </th>
                                                        <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-[#121212] dark:text-white font-bold text-sm leading-snug !text-left">
                                                            {t("recruitment.home.ads_list.title")}
                                                        </th>
                                                        <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-[#121212] dark:text-white font-bold text-sm leading-snug !text-left">
                                                            {t("recruitment.home.ads_list.last_date")}
                                                        </th>
                                                        <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-[#121212] dark:text-white font-bold text-sm leading-snug !text-center">
                                                            {t("recruitment.home.ads_list.status")}
                                                        </th>
                                                        <th className="px-[16px] py-[3px] xlx:py-[6px] h-full"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Array.isArray(data) && data.map((item: any, index: number) => (
                                                        <tr className={`${((index % 2) === 0) ? "bg-[#FCFCFC] dark:bg-[#343539]" : "bg-[#F6F9FC] dark:bg-[#3f4143]"} border border-[#E5E5E5] dark:border-[#454545]`} key={index}>
                                                            <td className="px-[16px] py-[15px] xlx:py-[30px] text-base font-medium text-blackDark dark:text-textBlackDark text-center">
                                                                {(page - 1) * 10 + index + 1}
                                                            </td>
                                                            <td className="px-[16px] py-[15px] xlx:py-[30px] text-base *:text-base font-medium text-blackDark dark:text-textBlackDark">
                                                                <div className="w-[210px] xlx:w-[240px]">
                                                                    {/* w-[350px] xlx:w-[390px] */}
                                                                    {item?.title}
                                                                </div>
                                                            </td>
                                                            <td className="px-[16px] py-[15px] xlx:py-[30px] text-base *:text-base font-medium text-blackDark dark:text-textBlackDark">
                                                                <div className="w-[210px] xlx:w-[240px]">
                                                                    {item?.adv_no}
                                                                </div>
                                                            </td>
                                                            <td className="px-[16px] py-[15px] xlx:py-[30px] text-base font-medium text-blackDark dark:text-textBlackDark whitespace-nowrap">
                                                                {moment(item?.last_date_submission).format('MMM DD, YYYY')}
                                                            </td>

                                                            <td className="px-[16px] py-[15px] xlx:py-[30px]">
                                                                <div className="flex items-center justify-center">
                                                                    <div className={`${item?.status?.toLowerCase() === "open" ? "bg-[rgba(0,128,0,0.10)] text-[#008000] dark:bg-[#1f8642] dark:text-white" : "bg-[rgba(255,0,0,0.10)] text-danger dark:bg-[#c86161] dark:text-white"} px-[20px] h-[25px] xlx:h-[30px] flex items-center justify-center w-fit text-base font-medium rounded-[30px] capitalize`}>
                                                                        {item?.status}
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className="px-[16px] py-[15px] xlx:py-[30px]">
                                                                <div className="flex items-center justify-center">
                                                                    <SecondaryBtn title={t("recruitment.home.view")} css="px-[15px] xlx:px-[30px] uppercase font-bold" onClick={() => { index === 0 ? window.open(item?.attach_pdf, '_blank') : !!params?.lang ? navigate(`/${params?.lang}/vacancies/${item?.id}`) : navigate(`/vacancies/${item?.id}`) }} />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                {/* pagination */}
                                <div className="flex items-center justify-center w-full">
                                    <PaginationComponent
                                        page={page}
                                        total={totalPages}
                                        setPage={setPage}
                                    />
                                </div>
                            </>}
                    </div>}
                </>
            }
        </>
    );
};

export default AllVacancies;